module.exports = __webpack_public_path__ + "static/media/esd-airflowrate.2fde10c4.png";